import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { B2BCompany } from 'npx-family-happy-common';
import { Page } from 'npx-family-happy-common';
import { BehaviorSubject } from 'rxjs';
import { Observable } from 'rxjs';
import { CompanySize } from 'npx-family-happy-common';

export interface B2BCompanyExtended extends B2BCompany {
  passive?: boolean;
}

export interface B2BCompanyFilters {
  id: string | null;
  name: string | null;
  vatNumber: string | null;
  size: string | null;
  passive?: boolean | null;
}

export const DEFAULT_B2B_COMPANY_FILTERS: B2BCompanyFilters = {
  id: null,
  name: null,
  vatNumber: null,
  size: null,
  passive: false,
};

@Injectable({
  providedIn: 'root',
})
export class B2BCompanyServices {
  private baseUrl = `${environment.baseURL}/b2b-companies`;
  private filters = new BehaviorSubject<B2BCompanyFilters>(
    DEFAULT_B2B_COMPANY_FILTERS
  );

  constructor(private http: HttpClient) {}

  getAllCompanies(
    page: number,
    pageSize: number,
    filters: B2BCompanyFilters
  ): Observable<Page<B2BCompanyExtended>> {
    let url = `${this.baseUrl}?page=${page}&pageSize=${pageSize}`;

    if (filters.id) {
      url += `&id=${filters.id}`;
    }
    if (filters.name) {
      url += `&name=${filters.name}`;
    }
    if (filters.vatNumber) {
      url += `&vatNumber=${filters.vatNumber}`;
    }
    if (filters.size) {
      url += `&companySize=${filters.size}`;
    }
    if (filters.passive !== null && filters.passive !== undefined) {
      url += `&passive=${filters.passive}`;
    }

    return this.http.get<Page<B2BCompany>>(url);
  }

  getCompanyById(id: string): Observable<B2BCompanyExtended> {
    return this.http.get<B2BCompanyExtended>(`${this.baseUrl}/${id}`);
  }

  getCompanyByVatNumber(vatNumber: string) {
    return this.http.get<B2BCompanyExtended>(
      `${this.baseUrl}/vat/${vatNumber}`
    );
  }

  createCompany(
    id: string,
    name: string,
    vatNumber: string | null,
    size: CompanySize | null,
    logoUrl: string | null,
    passive: boolean | null
  ): Observable<B2BCompanyExtended> {
    return this.http.post<B2BCompanyExtended>(this.baseUrl, {
      id,
      name,
      vatNumber,
      size,
      logoUrl,
      passive,
    });
  }

  updateCompany(
    id: string,
    name: string,
    vatNumber: string | null,
    size: CompanySize | null,
    logoUrl: string | null,
    passive: boolean | null
  ): Observable<B2BCompanyExtended> {
    return this.http.put<B2BCompanyExtended>(`${this.baseUrl}/${id}`, {
      id,
      name,
      vatNumber,
      size,
      logoUrl,
      passive,
    });
  }

  deleteCompany(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }

  setFilters(filters: B2BCompanyFilters) {
    this.filters.next(filters);
  }

  getFilters() {
    return this.filters.asObservable();
  }
}
